import { SelectItem } from 'primeng/primeng';
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { MdDialog } from '@angular/material';

import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';
import { ConstantsService } from 'app/services/constants-service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { GenericSearchDetails } from 'app/shared/models/generic-search-details.model';

import { TimesheetModel } from 'app/shared/models/timesheet.model';
import { TimesheetService } from './timesheet.service';

@Component({
    templateUrl: './timesheet.component.html',
    providers: [TimesheetService]
})

/**
 * Component for displaying and saving time keeping details dialog.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class TimesheetComponent implements OnInit {
    @Input() timsheet: TimesheetModel;

    timeKeepingForm: FormGroup;
    activities: ApplicationValue[];
    savingTimesheet: boolean;
    selectedClient: any;
    clientSearchURI = ConstantsService.LOAD_CLIENT_SUGGESTIONS;
    searchPlaceholder = MessageService.CLIENT_SEARCH_PLACEHOLDER;

    formErrors = {
        'date': '',
        'activity': '',
        'hours': ''
    };

    validationMessages = {
        'date': {
            'required': 'Required field value.',
        },
        'activity': {
            'required': 'Required field value.',
        },
        'hours': {
            'required': 'Required field value.',
            'pattern': 'Invalid Hours.',
        }
    };

    constructor(private formBuilder: FormBuilder,
        private warmUpService: WarmUpService,
        private timesheetService: TimesheetService,
        private cdr: ChangeDetectorRef,
        private snackBarService: SnackBarService,
        private dialog: MdDialog) { }

    ngOnInit(): void {
        this.buildForm();
        this.setUpActivities(this.warmUpService.getApplicationValue(ApplicationTypeConstants.TIME_KEEPING));
    }

    setUpActivities(dropDownValues: any) {
        if (dropDownValues instanceof Observable) {
            dropDownValues.subscribe(
                response => {
                    this.warmUpService.setApplicationTypeInLS(response);
                    this.activities = response.values;
                    this.cdr.detectChanges();
                }
            );
        } else {
            this.activities = dropDownValues;
        }
    }

    buildForm() {
        this.timeKeepingForm = this.formBuilder.group({
            clientId: '',
            date: ['', Validators.required],
            activity: ['', Validators.required],
            description: '',
            hours: ['', Validators.required]
        });

        this.timeKeepingForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged(); // (re)set validation messages now
    }

    onValueChanged(data?: any) {
        if (!this.timeKeepingForm) {
            return;
        }
        const form = this.timeKeepingForm;

        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control && control.touched && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }

    onSubmit({ value }: { value: TimesheetModel }) {
        this.timesheetService.saveTimesheet(value)
            .subscribe(
            success => {
                this.savingTimesheet = false;
                this.callSnackBarService(success);
                this.dialog.closeAll();
            },
            err => {
                this.savingTimesheet = false;
                this.callSnackBarService(err);
            }
            );
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.TIME_KEEPING_DETAILS_SAVED_SUCCESSFULL,
            MessageService.TIME_KEEPING_DETAILS_SAVED_FAILURE);
    }

    onClientSelectionEvent(searchDetails: GenericSearchDetails) {
        this.selectedClient = searchDetails.clientName;
        this.timeKeepingForm.controls['clientId'].setValue(searchDetails.clientId);
    }
}



// WEBPACK FOOTER //
// ./src/app/header/navigationbar/timesheethandler/timesheet.component.ts